module.exports = __webpack_public_path__ + "img/ExtraBoost.5175ada9.png";